import { Route, Switch } from "react-router-dom";
import React from "react";
import Home from "../home/Home";
import PurchaseOrder from "../purchase/order/Order";
import PurchaseInvoice from "../purchase/invoice/Invoice";
import PurchasePo from "../purchase/po/Po";
import PurchaseRo from "../purchase/ro/Ro";

import SaleOrder from "../sale/order/Order";
import SaleSo from "../sale/so/So";
import SaleRo from "../sale/ro/Ro";

import BillCustomer from "../bill/customer/Customer";
import BillCustomerDetail from "../bill/customer/CustomerBillDetail"
import BillSupplier from "../bill/supplier/Supplier";
import BillSupplierDetail from "../bill/supplier/SupplierBillDetail"

import StockStatistic from "../stock/statistic/Statistic";
import StockCheck from "../stock/check/Check";

import BaseMaterial from "../base/material/Material";
import MaterialDetail from "../base/material/MaterialDetail";
import MaterialAdd from "../base/material/MaterialAdd";
import BaseWarehouse from "../base/warehouse/Warehouse";
import WarehouseDetail from "../base/warehouse/WarehouseDetail";
import WarehouseAdd from "../base/warehouse/WarehouseAdd";
import BaseSupplier from "../base/supplier/Supplier";
import SupplierDetail from "../base/supplier/SupplierDetail";
import SupplierAdd from "../base/supplier/SupplierAdd";
import BaseDict from "../base/dict/Dict";
import BaseCustomer from "../base/customer/Customer";
import CustomerDetail from "../base/customer/CustomerDetail";
import CustomerAdd from "../base/customer/CustomerAdd";

import PurchaseOrderDetail from "../purchase/order/OrderDetail";
import PurchaseOrderAdd from "../purchase/order/OrderAdd";
import PurchaseInvoiceDetail from "../purchase/invoice/InvoiceDetail";
import PurchasePoDetail from "../purchase/po/PoDetail";
import PurchasePoAdd from "../purchase/po/PoAdd";
import PurchaseRoDetail from "../purchase/ro/RoDetail";
import PurchaseRoAdd from "../purchase/ro/RoAdd";

import SaleOrderDetail from "../sale/order/OrderDetail";
import SaleOrderAdd from "../sale/order/OrderAdd";
import SaleSoDetail from "../sale/so/SoDetail";
import SaleSoAdd from "../sale/so/SoAdd";
import SaleRoDetail from "../sale/ro/RoDetail";
import SaleRoAdd from "../sale/ro/RoAdd";

import CheckDetail from "../stock/check/CheckDetail";
import CheckAdd from "../stock/check/CheckAdd";

import SettingCache from "../setting/cache/Cache";

import PartDeal from "../statistics/partDeal";
import Dinout from "../statistics/dinout";
import CustomerSale from "../statistics/customerSale";
import Supplier from "../statistics/supplier";
import PartOrCustomer from "../statistics/partOrCustomer";
// import Tst from "../tst/Tst";

export default function () {

    return <Switch>
        <Route path="/" exact component={Home} />

        <Route path="/purchase/order" exact component={PurchaseOrder} />
        <Route path="/purchase/order/detail" component={PurchaseOrderDetail} />
        <Route path="/purchase/order/add" component={PurchaseOrderAdd} />

        <Route path="/purchase/invoice" exact component={PurchaseInvoice} />
        <Route path="/purchase/invoice/detail" component={PurchaseInvoiceDetail} />

        <Route path="/purchase/po" exact component={PurchasePo} />
        <Route path="/purchase/po/detail" component={PurchasePoDetail} />
        <Route path="/purchase/po/add" component={PurchasePoAdd} />

        <Route path="/purchase/ro" exact component={PurchaseRo} />
        <Route path="/purchase/ro/detail" component={PurchaseRoDetail} />
        <Route path="/purchase/ro/add" component={PurchaseRoAdd} />


        <Route path="/sale/order" exact component={SaleOrder} />
        <Route path="/sale/order/detail" component={SaleOrderDetail} />
        <Route path="/sale/order/add" component={SaleOrderAdd} />

        <Route path="/sale/so" exact component={SaleSo} />
        <Route path="/sale/so/detail" component={SaleSoDetail} />
        <Route path="/sale/so/add" component={SaleSoAdd} />

        <Route path="/sale/ro" exact component={SaleRo} />
        <Route path="/sale/ro/detail" component={SaleRoDetail} />
        <Route path="/sale/ro/add" component={SaleRoAdd} />

        <Route path="/bill/customer" exact component={BillCustomer} />
        <Route path="/bill/customer/detail" component={BillCustomerDetail} />

        <Route path="/bill/supplier" exact component={BillSupplier} />
        <Route path="/bill/supplier/detail" component={BillSupplierDetail} />

        <Route path="/stock/statistic" component={StockStatistic} />

        <Route path="/stock/check" exact component={StockCheck} />
        <Route path="/stock/check/detail" component={CheckDetail} />
        <Route path="/stock/check/add" component={CheckAdd} />

        <Route path="/base/material" exact component={BaseMaterial} />
        <Route path="/base/material/detail" component={MaterialDetail} />
        <Route path="/base/material/add" component={MaterialAdd} />

        <Route path="/base/warehouse" exact component={BaseWarehouse} />
        <Route path="/base/warehouse/detail" component={WarehouseDetail} />
        <Route path="/base/warehouse/add" component={WarehouseAdd} />

        <Route path="/base/customer" exact component={BaseCustomer} />
        <Route path="/base/customer/detail" component={CustomerDetail} />
        <Route path="/base/customer/add" component={CustomerAdd} />

        <Route path="/base/supplier" exact component={BaseSupplier} />
        <Route path="/base/supplier/detail" component={SupplierDetail} />
        <Route path="/base/supplier/add" component={SupplierAdd} />

        <Route path="/base/dict" component={BaseDict} />

        <Route path="/setting/cache" component={SettingCache} />

        <Route path="/statistics/partDeal" exact component={PartDeal} />
        <Route path="/statistics/dinout" exact component={Dinout} />
        <Route path="/statistics/CustomerSale" exact component={CustomerSale} />
        <Route path="/statistics/Supplier" exact component={Supplier} />
        <Route path="/statistics/partOrCustomer" exact component={PartOrCustomer} />
    </Switch>
}
